import { ThunkAction } from 'redux-thunk';

import HomeAPI from '~/repositories/home';
import * as MessageService from '~/services/message';

import { SET_HOME } from './actionTypes';
import { CardActions, LoadingActions } from '.';
import { SetAvailableCardsAction } from './cards';
import { LoadingAction } from './loading';

export type SetHomeAction = {
  type: string;
  payload: models.HomeResponse;
};

export const getHome =
  (
    load = true
  ): ThunkAction<
    void,
    reducers.rootReducer,
    unknown,
    SetHomeAction | SetAvailableCardsAction | LoadingAction
  > =>
  async (dispatch) => {
    if (load) {
      dispatch(LoadingActions.increaseLoading());
    }
    try {
      const payload = await HomeAPI.get();
      dispatch({
        type: SET_HOME,
        payload,
      });

      dispatch(CardActions.setAvailableCards(payload.availableCards));
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (load) {
        dispatch(LoadingActions.decreaseLoading());
      }
    }
  };
